import "reflect-metadata"
import Vue from "vue"
import AmplilyWidget from "./timeline-widget.vue"
import state from "../mixins/state"
import { AwOptions } from "../models/AwOptions"
import { callSetup } from "@/services/setupAmplilyWidget"
import { getIdentifierKey } from "@/services/getIdentifierKey"
import getParams from "@/services/getParams"
import { addMetaTag } from "@/services/addMetaTag"
import isPreview from "@/services/isPreview"
import addMaterialIcons from "@/services/addMaterialDesign"
import logger from "../logLevel"
import { WebinarDataService } from "@/services/WebinarDataServices"
import { container } from "tsyringe"
import {
  registerAnalyticsService,
  registerWebinarDataService
} from "@/tsyringe.config"
Vue.config.productionTip = process.env.NODE_ENV != "production"
;(window as any).setupAmplilyTimeline = (options: AwOptions) => {
  const el = document.getElementsByClassName("parmonic-widget")[0]
  new Vue({
    render: h => h(AmplilyWidget),
    mixins: [state],
    data() {
      return {
        momentstyle: ""
      }
    },
    created() {
      this.$data.logger = logger
      addMetaTag()
      addMaterialIcons()
      this.$data.identifierKey = getIdentifierKey()
      if (options && options.apiEndpoint)
        this.$data.baseurlAdminAppUrl = options.apiEndpoint + "/"
      if (options && options.dataEndpoint)
        this.$data.PublishedWebinarDataEndPoint = options.dataEndpoint + "/"
      this.$data.queryEndpoint =
        options && options.queryEndpoint ? options.queryEndpoint : ""
      this.$data.analyticsEventsCaptureEndPoint = `${this.$data.baseurlAdminAppUrl}api/v4/event`
      this.$data.socialShareUrl = this.$data.isLocalhost
        ? this.$data.localbase
        : "https://snackified.co/videos/"
      setTimeout(this.focus, 2000)
      registerAnalyticsService(
        isPreview() || process.env.NODE_ENV != "production"
      )
      registerWebinarDataService(false)
      const _dataService = container.resolve(WebinarDataService)
      _dataService.setUp(
        this.$data.PublishedWebinarDataEndPoint,
        this.$data.queryEndpoint,
        {}
      )
    },
    methods: {
      focus() {
        const url = window.location.search
        if (url.length == 0) return
        const momentdiv = document.getElementById(
          "moment-" + getParams(url)
        ) as HTMLElement
        if (momentdiv) {
          momentdiv.scrollIntoView(true)
          this.$data.momentstyle = momentdiv.getAttribute("style")
          momentdiv.setAttribute(
            "style",
            this.$data.momentstyle + ";background-color:#F1D9FF !important"
          )

          setTimeout(this.restoremomentdiv, 2000)
        }
      },
      restoremomentdiv() {
        const url = window.location.search
        const momentdiv = document.getElementById(
          "moment-" + getParams(url)
        ) as HTMLElement
        momentdiv.setAttribute(
          "style",
          this.$data.momentstyle +
            ";" +
            "transition: background-color 0.5s linear !important;" +
            "-moz-transition: background-color 0.5s linear !important; " +
            "-webkit-transition: background-color 0.5s linear !important; " +
            "-ms-transition: background-color 0.5s linear !important; "
        )
      }
    }
  }).$mount(el!)
}
callSetup()
